import React, { FC } from "react";
import Link from "next/link";
import Router from "next/router";
import { Query } from "react-apollo";
import styled, { css } from "styled-components";
import { opacityHover } from "../styles/atoms";
import getUndef from "../../lib/get-undef";
import { GET_PIZZA_DAY, getPizzaDayProductPath } from "../../queries/PizzaDay";

const pizzaDayLabel = css`
  background: #ff3a29;
  color: #fff;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  white-space: nowrap;
  ${opacityHover};
`;

const PizzaDayBadge: FC<{ small?: boolean; productSlug: string }> = ({
  small,
  productSlug,
}) => {
  const productPath = getPizzaDayProductPath(productSlug);

  return (
    <Badge
      type="button"
      small={small}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (Router.asPath !== productPath) {
          Router.push(productPath);
        }
      }}
    >
      Пицца дня
    </Badge>
  );
};

const Badge = styled.button<{ small?: boolean }>`
  ${pizzaDayLabel};
  display: inline-block;
  margin-bottom: 10px;
  padding: ${({ small }) => (small ? "4px 8px" : "2.5px 8px")};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;

  @media (max-width: 550px) {
    font-size: 10px;
    padding: 4px 8px;
  }
`;

const NavLink = styled.a`
  ${pizzaDayLabel};
  display: inline-flex;
  width: 99px;
  height: 24px;
  margin-bottom: 10px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  box-sizing: border-box;
  cursor: pointer;
`;

export const PizzaDayMenuLink: FC = () => (
  <Query query={GET_PIZZA_DAY}>
    {(result) => {
      if (result.loading || result.error) {
        return null;
      }

      const slug = getUndef(() => result.data.shop.pizzaDay.productSlug);

      if (!slug) {
        return null;
      }

      const productPath = getPizzaDayProductPath(slug);

      return (
        <Link href="/catalog/[code]/[item]" as={productPath}>
          <NavLink href={productPath}>Пицца дня</NavLink>
        </Link>
      );
    }}
  </Query>
);

export default PizzaDayBadge;
